const topics = [
  { name: '暑期档必看', count: '12.6万', hot: true },
  { name: '科幻大片', count: '9.8万', hot: true },
  { name: '国漫崛起', count: '8.3万', hot: true },
  { name: '高分悬疑', count: '7.5万', hot: false },
  { name: '经典港片', count: '6.9万', hot: false },
  { name: '韩剧热播', count: '6.2万', hot: true },
  { name: '日漫新番', count: '5.8万', hot: false },
  { name: '纪录片', count: '5.1万', hot: false },
  { name: '宫斗剧', count: '4.7万', hot: false },
  { name: '综艺合集', count: '4.3万', hot: false },
  { name: '4K专区', count: '3.9万', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-50 mb-3">热门话题</h2>
          <p className="text-sm text-foreground-500">全网热议影视话题，找到你的兴趣圈子</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((t) => (
            <a
              key={t.name}
              href="#topics"
              className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full border transition-all cursor-pointer ${
                t.hot
                  ? 'bg-primary-500/10 border-primary-500/30 hover:bg-primary-500/20'
                  : 'bg-background-50 border-background-200/50 hover:border-primary-500/30'
              }`}
            >
              {t.hot && (
                <i className="ri-fire-fill text-accent-400 text-xs"></i>
              )}
              <span className={`text-sm font-medium whitespace-nowrap ${
                t.hot ? 'text-primary-400' : 'text-foreground-300'
              }`}>
                #{t.name}
              </span>
              <span className="text-xs text-foreground-600 whitespace-nowrap">{t.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}